module.exports = __webpack_public_path__ + "static/media/career_website_banner.b1cf320b.jpg";